import { render } from "./PaginationBar.vue?vue&type=template&id=d41ebfd0&ts=true"
import script from "./PaginationBar.vue?vue&type=script&lang=ts"
export * from "./PaginationBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__